import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { AddActivityFormatComponent } from '../add-format/add-format.component';
import { EditActivityFormatComponent } from '../edit-format/edit-format.component';
import { ActivityFormat } from '../../../core/models';
import {
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, 
  ChurchService, DatabaseService, DocumentService, FestivalUserService 
} from '../../../core/services';

import { PageClass } from '../../../core/classes/page';

@Component({
  selector: 'app-activity-format-list',
  templateUrl: './format-list.component.html',
  styleUrls: ['./format-list.component.less', '../../../core/styles/common.less']
})

export class ActivityFormatListComponent extends PageClass implements OnInit {

  formatList: ActivityFormat[] = [];
  activityList: any[] = [];
  categoryList: any[] = [];
  filter: any = { activity: undefined, category: undefined };

  constructor(
    private activityFormatService: ActivityFormatService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private docService: DocumentService,
    protected modalController: ModalController,
    protected festivalUserService: FestivalUserService
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    
    this.activityList = this.currentUser.isAdmin ? 
        this.activityFormatService.getActivityList() :
        this.currentUser.activityList;

    

    if (this.activityList.length === 1) {
      this.filter.activity = this.activityList[0];
      this.loadActivities();
    }

    this.isLoading = false;
  }

  public loadActivities = async () => {

    this.isLoading = true;  
    this.activityFormatService.getFormatList(this.filter.activity)
      .subscribe(formatList => {
        this.formatList = formatList.sort(this.arrayService.orderByDisplayName);
        this.isLoading = false;
    });
  } 

  doRefresh = async (event) => {
    await this.loadData();
    event.target.complete();
  }

  public async addFormat() {
    const modal = await this.modalController.create({
      component: AddActivityFormatComponent,
      componentProps: {
      }
    });
    return await modal.present();
  }

  public async editFormat (format: ActivityFormat) {
    const modal = await this.modalController.create({
      component: EditActivityFormatComponent,
      componentProps: {
        format
      }
    });
    return await modal.present();
  }

  deleteFormat = (formatId: string) => {
    this.docService.deleteDocument(this.activityFormatService.collection, formatId);
  }
}
